import { render, staticRenderFns } from "./RecordHistory.vue?vue&type=template&id=74c9f2d9"
import script from "./RecordHistory.vue?vue&type=script&lang=js"
export * from "./RecordHistory.vue?vue&type=script&lang=js"
import style0 from "./RecordHistory.vue?vue&type=style&index=0&id=74c9f2d9&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/actions-runner/_work/treasurenet-tnservices-servicesplatform-fe/treasurenet-tnservices-servicesplatform-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74c9f2d9')) {
      api.createRecord('74c9f2d9', component.options)
    } else {
      api.reload('74c9f2d9', component.options)
    }
    module.hot.accept("./RecordHistory.vue?vue&type=template&id=74c9f2d9", function () {
      api.rerender('74c9f2d9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/transfer/RecordHistory.vue"
export default component.exports